<script>
import WebNavbar from "@/components/webnavbar";
import Contact from "@/components/contact";
import Footer from "@/components/footer";
import officesData from "@/data/offices.json";

export default {
  components: {
    WebNavbar,
    Contact,
    Footer,
  },
  data() {
    return {
      offices: officesData.offices,
      meta: officesData.meta,
    };
  },
  methods: {
    monthlyPrice(office) {
      const rate =
        office.rate_override != null
          ? office.rate_override
          : this.meta.rate_per_sqft_year;
      // monthly_price = sqft * rate_per_sqft_year / 12
      return (office.sqft * rate) / 12;
    },
    formatMoney(amount) {
      return "$" + amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    typeLabel(type) {
      const labels = {
        office: "Office",
        conference: "Conference",
        copy: "Copy",
        placeholder: "Add-on Space",
      };
      return labels[type] || type;
    },
    availabilityLabel(availability) {
      return availability === "available" ? "Available" : "Unavailable";
    },
  },
};
</script>

<template>
  <div>
    <WebNavbar :navcolor="'light'" />
    <div v-scroll-spy>
      <!-- Hero Start -->
      <section
        class="hero-2 position-relative overflow-hidden pt-5"
        id="home"
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 font-size-17">
              <h1 class="font-weight-semibold mb-4 hero-2-title pt-5">
                Office Space at 52 Wall St
              </h1>
              <p class="text-muted mb-0">
                Explore the available offices and suites in our building. The
                floor plan is shown alongside a detailed list of each room,
                its size, and its availability.
              </p>
            </div>
          </div>
        </div>
      </section>
      <!-- Hero End -->

      <!-- Floor plan & offices start -->
      <section class="section">
        <div class="container">
          <div class="row">
            <!-- Floor plan image -->
            <div class="col-lg-6">
              <img
                :src="require('@/assets/images/offices.png')"
                alt="52 Wall St floor plan"
                class="img-fluid rounded shadow mb-4 mb-lg-0"
              />
            </div>
            <!-- end col -->

            <!-- Offices table -->
            <div class="col-lg-6">
              <div class="table-responsive">
                <table class="table table-striped table-hover mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Room</th>
                      <th scope="col">Type</th>
                      <th scope="col" class="text-end">Sqft</th>
                      <th scope="col">Status</th>
                      <th scope="col" class="text-end">$/mo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="office in offices" :key="office.map_id">
                      <td>
                        <span class="font-weight-semibold">{{ office.room }}</span>
                        <span
                          v-if="!office.standalone"
                          class="badge bg-soft-primary ms-1 font-size-11"
                          >add-on</span
                        >
                      </td>
                      <td>{{ typeLabel(office.type) }}</td>
                      <td class="text-end">{{ office.sqft }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="
                            office.availability === 'available'
                              ? 'bg-soft-success text-success'
                              : 'bg-soft-danger text-danger'
                          "
                          >{{ availabilityLabel(office.availability) }}</span
                        >
                      </td>
                      <td class="text-end">
                        {{ formatMoney(monthlyPrice(office)) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- end container -->
      </section>
      <!-- Floor plan & offices end -->

      <Contact />
      <Footer />
    </div>
  </div>
</template>
